import React, { useState } from 'react';
import * as Styles from 'components/manage-vm/settings-panel/SettingsPanel.style';
import CustomButton from 'components/common/custom-button';
import { Grid, useMediaQuery } from '@mui/material';
import { AddIP, EditLabel, IPContainer } from 'components/manage-vm/settings-panel/components';
import { useMutation, useQuery } from 'react-query';
import { get } from 'lodash';
import moment from 'moment';
import Loading from 'components/common/loading';
import { disableStyles, isInProgress, isIpv6InProgress } from 'components/manage-vm/utils';
import hooks from 'hooks';
import { DELETE_SERVER_IP, INFO_ACTION, INSTANCE_ACTION } from 'components/manage-vm/queries';
import { checkDeletedItems } from 'components/manage-vm/utils';
import { Trans, useTranslation } from 'react-i18next';
import { features, extraFeatures, extraWithMegaraidFeatures } from './util';
import { Icon } from 'semantic-ui-react';
import { Feature, Extra } from 'components/bm-deployment/server-size-card/ServerSizeCard.style';
import { filterDataKey2, filterMemoryType, filterCount2 } from 'components/bm-deployment/server-size-card/utils';
import ConditionalFragment from 'components/conditional-fragment';
import { useSelector } from 'react-redux';
import { userRights } from 'store/selectors/user-details';
import { H6, P } from 'components/reusable-css';
import Heading from 'components/Heading/Heading';
import { createFeatures } from 'components/vm-deployment/constants';
import { Highlight } from 'components/common';
import Toggle from 'components/common/toggle';
import LoadingImage from 'assets/images/loading.svg';
import Select from 'components/select';

const ipV6SubnetArr = [
  {
    value: '64',
    text: 'vs/instance.string227',
  },
  {
    value: '56',
    text: 'vs/instance.string227',
  },
];

const InfoManager = (props) => {
  const { t } = useTranslation();
  const { data, serverSizeData, managerVmRefetch, allTags, isTags, statusOfServer, managerVmIsFetching, type } = props;
  const { refreshTime, mutationProps } = hooks();
  const [isFetching, setIsFetching] = useState(false);
  const [deletedItem, setDeletedItem] = useState('');
  const [deletedIps, setDeletedIps] = useState([]);
  const [openTag, setOpenTag] = useState(false);
  const [preferenceEnabled, setPreferenceEnabled] = useState(data?.private_vlan == 1 ? true : false);
  const [preferencePublicEnabled, setPreferencePublicEnabled] = useState(data?.public_ipv4_vlan == 1 ? true : false);
  const [preferencePublicV6Enabled, setPreferencePublicV6Enabled] = useState(
    data?.public_ipv6_vlan == 1 ? true : false,
  );
  const { mutate: refreshServer, isLoading: refreshServerLoading } = useMutation(INSTANCE_ACTION);
  const match = useMediaQuery('(min-width:1460px)');
  const match1 = useMediaQuery('(max-width:1460px)');
  const buttonStyle = match
    ? { marginLeft: '5px', height: '3.6rem' }
    : match1
    ? { marginTop: '5px', height: '3.6rem' }
    : null;
  const [deletedV6Item, setDeletedV6Item] = useState('');
  const [deletedIpsV6, setDeletedIpsV6] = useState([]);
  const [selectedValueIp, setSelectedValueIp] = useState(ipV6SubnetArr[0].value);
  const [isIpv6Fetching, setIsIpv6Fetching] = useState(false);
  const handleToggle = async (e) => {
    const isEnabled = e.target.checked;
    setPreferenceEnabled(isEnabled);
    await refreshServer(
      { id: data.id, type, action: isEnabled ? 'enablepvlan' : 'disablepvlan' },
      {
        ...mutationProps('', {
          onSuccess: () => {
            if (managerVmRefetch) managerVmRefetch();
          },
          onError: () => {
            setPreferenceEnabled(data?.private_vlan == 1 ? true : false);
          },
        }),
      },
    );
  };
  const handlePublicToggle = async (e) => {
    const isEnabled = e.target.checked;
    setPreferencePublicEnabled(isEnabled);
    await refreshServer(
      { id: data.id, type, action: isEnabled ? 'enablepublicipv4port' : 'disablepublicipv4port' },
      {
        ...mutationProps('', {
          onSuccess: () => {
            if (managerVmRefetch) managerVmRefetch();
          },
          onError: () => {
            setPreferencePublicEnabled(data?.public_ipv4_vlan == 1 ? true : false);
          },
        }),
      },
    );
  };
  const handlePublicV6Toggle = async (e) => {
    const isEnabled = e.target.checked;
    setPreferencePublicV6Enabled(isEnabled);
    await refreshServer(
      { id: data.id, type, action: isEnabled ? 'enablepublicipv6port' : 'disablepublicipv6port' },
      {
        ...mutationProps('', {
          onSuccess: () => {
            if (managerVmRefetch) managerVmRefetch();
          },
          onError: () => {
            setPreferencePublicV6Enabled(data?.public_ipv6_vlan == 1 ? true : false);
          },
        }),
      },
    );
  };
  const handleClose = () => setOpenTag(false);
  const handleOpen = () => setOpenTag(true);
  const checkDisabledItem = (ip) => checkDeletedItems(deletedIps, ip);
  const checkDisabledItemV6 = (ip) => checkDeletedItems(deletedIpsV6, ip);
  const networkType = `${type}_ipv4[0]`;
  const {
    data: networkData,
    isLoading: networkLoading,
    refetch: ipRefetch,
  } = useQuery(`/${type || 'vs'}/instance/${data.id}/ipv4`, {
    ...(isFetching ? { refetchInterval: refreshTime } : {}),
    onSuccess: (res) => {
      setDeletedIps([]);
      setDeletedItem('');
      setIsFetching(isInProgress(get(res, networkType, {})));
    },
  });
  const { data: sizeData, isLoading: sizeDataLoading } = useQuery(`/vs/sizes/${data?.size}`);
  const network = get(networkData, networkType, {});
  const {
    data: networkDataIpv6,
    isLoading: networkIpv6Loading,
    refetch: ipV6Refetch,
    isRefetching: ipV6IsRefetching,
  } = useQuery(`/vs/instance/${data.id}/ipv6`, {
    ...(isIpv6Fetching ? { refetchInterval: refreshTime } : {}),
    onSuccess: (res) => {
      setDeletedIpsV6([]);
      setDeletedV6Item('');
      setIsIpv6Fetching(isIpv6InProgress(get(res, 'vs_ipv6[0]', {})));
    },
  });
  const networkIpv6 = get(networkDataIpv6, 'vs_ipv6[0]', {});

  const { mutate: deleteIp, isLoading: deleteIpLoad } = useMutation(DELETE_SERVER_IP, {
    ...mutationProps('', {
      onSuccess: async () => {
        ipRefetch();
        setDeletedItem('');
        managerVmRefetch();
        // await ipRefetch();
      },
      onError: () => {
        setDeletedItem('');
      },
    }),
  });
  const { mutate: addIpV6Subnet, isLoading: addIpV6SubnetLoading } = useMutation(INSTANCE_ACTION);
  const { mutate: deleteIpv6, isLoading: deleteIpv6Loading } = useMutation(INFO_ACTION);
  const handleIpv6Subnet = async () => {
    await addIpV6Subnet(
      { id: data.id, type: 'vs', action: 'addroutedipv6', size: selectedValueIp },
      {
        ...mutationProps('', {
          onSuccess: () => {
            ipV6Refetch();
            setSelectedValueIp(ipV6SubnetArr[0].value);
            managerVmRefetch();
          },
        }),
      },
    );
  };
  const handleDelete = async (ip) => {
    setDeletedItem(ip);
    await deleteIp(
      { id: data.id, ip: ip },
      {
        onSuccess: () => {
          setDeletedIps([...deletedIps, ip]);
        },
      },
    );
  };
  const handleDeleteIpV6 = async (ip) => {
    setDeletedV6Item(ip.route);
    await deleteIpv6(
      { instance_id: data.id, id: ip.id, action: 'deleteroutedipv6', type: 'vs' },
      {
        onSuccess: () => {
          setDeletedIpsV6([...deletedIpsV6, ip]);
          ipV6Refetch();
        },
      },
    );
  };
  const checkIpQuantity = (quantity) => {
    return get(network, 'networks', []).some((network) =>
      network.eth0?.some(
        (eth) => eth.ipv4?.filter((item) => !deletedIps.some((obj) => obj === item.ip)).length === quantity,
      ),
    );
  };

  const rights = useSelector(userRights);

  const serverVmSizes = sizeData?.vs_sizes.length > 0 ? sizeData?.vs_sizes[0] : {};

  // Check if any 'routed' object contains a non-empty 'ip'
  const hasEth2RoutedIP = get(networkIpv6, 'networks', []).some((networkObj) =>
    networkObj?.eth2?.some((item) => item.routed?.some((r) => r.route && r.route.trim() != '')),
  );

  // Check if any 'ipv6' object contains a non-empty 'ip'
  const hasEth2IPv6 = get(networkIpv6, 'networks', []).some((networkObj) =>
    networkObj?.eth2?.some((item) => item.ipv6?.some((r) => r.ip && r.ip.trim() != '')),
  );

  if (networkLoading || sizeDataLoading || networkIpv6Loading) {
    return <Loading />;
  }
  return (
    <Styles.InfoDetail>
      <div className="first">
        <H6 className="mb-4 ml-1">{type === 'bm' ? t('bm/instance.string38') : t('vs/instance.string113')}</H6>
        {type == 'bm' && (
          <>
            <Grid container>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicBottomMargin>
                  <Heading small name={'bm/instance.string40'} />
                </Styles.PublicBottomMargin>
              </Grid>
            </Grid>
            <ConditionalFragment condition={serverSizeData && Object.keys(serverSizeData).length}>
              {serverSizeData && Object.keys(serverSizeData).length && (
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12} />
                  <Styles.IPText style={{ margin: '0.5rem 1.6em' }}>
                    <Styles.ServerSizeCardSC>
                      <Styles.FlexCon>
                        <Styles.Name>{data?.size || t('bm/instance.string41')}</Styles.Name>
                      </Styles.FlexCon>
                      <Styles.Features>
                        {features.map((feature) => (
                          <Feature style={{ alignItems: 'center' }} key={feature.id}>
                            <Icon size="tiny" name="circle" />
                            <Trans
                              i18nKey={
                                feature.dataKey2 == 'cpu_sockets'
                                  ? serverSizeData[feature.dataKey2] == 1
                                    ? feature.langSingle
                                    : serverSizeData[feature.dataKey2] == 2
                                    ? feature.langDual
                                    : serverSizeData[feature.dataKey2] == 4
                                    ? feature.langQuad
                                    : null
                                  : serverSizeData[feature.dataKey] > 1
                                  ? feature.plural_lang
                                  : feature.lang
                              }
                              values={{
                                count: serverSizeData[feature.dataKey],
                                counts: filterDataKey2(serverSizeData[feature.dataKey2], feature.lanRef),
                                count2: filterCount2(serverSizeData[feature.dataKey3], feature.lanRef),
                                count3: filterMemoryType(serverSizeData[feature.dataKey2], feature.lanRef),
                              }}
                            />
                          </Feature>
                        ))}
                        {serverSizeData.extra_hardware_megaraid == 0 && serverSizeData.extra_hardware == 1 ? (
                          <div>
                            <br />
                            <Extra>{t('bm/instance.string54')}</Extra>
                            {extraFeatures.map((feature) => (
                              <Feature style={{ alignItems: 'center' }} key={feature.id}>
                                <Icon size="tiny" name="circle" />
                                <Trans
                                  i18nKey={feature.lang}
                                  values={{
                                    count: serverSizeData[feature.dataKey],
                                    counts: filterDataKey2(serverSizeData[feature.dataKey2], feature.lanRef),
                                    count2: filterCount2(serverSizeData[feature.dataKey3], feature.lanRef),
                                    count3: filterMemoryType(serverSizeData[feature.dataKey2], feature.lanRef),
                                  }}
                                />
                              </Feature>
                            ))}
                          </div>
                        ) : serverSizeData.extra_hardware_megaraid == 1 && serverSizeData.extra_hardware == 1 ? (
                          <div>
                            <br />
                            <Extra>{t('bm/instance.string54')}</Extra>
                            {extraWithMegaraidFeatures.map((feature) => (
                              <Feature style={{ alignItems: 'center' }} key={feature.id}>
                                <Icon size="tiny" name="circle" />
                                {t(feature.lang)}
                              </Feature>
                            ))}
                          </div>
                        ) : null}
                      </Styles.Features>
                    </Styles.ServerSizeCardSC>
                  </Styles.IPText>
                </Grid>
              )}
            </ConditionalFragment>
          </>
        )}
        {type === 'vs' && (
          <>
            <Grid container>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Heading small name={'vs/instance.string205'} />
              </Grid>
            </Grid>
            <ConditionalFragment condition={serverVmSizes && Object.keys(serverVmSizes).length}>
              <Grid container>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12} />
                <Styles.IPText style={{ margin: '0.5rem 1.6em' }}>
                  <Styles.ServerSizeCardSC>
                    <Styles.FlexCon>
                      <Styles.Name>{data.size.toUpperCase()}</Styles.Name>
                    </Styles.FlexCon>
                    <Styles.Features>
                      {createFeatures.map(
                        (feature) =>
                          ((feature.lanRef == 'additional_bandwidth_gb_month' &&
                            (data['additional_bandwidth_gb_month'] > 0 ||
                              data['additional_bandwidth_gb_month'] != '')) ||
                            (feature.lanRef == 'ddos_protection' && serverVmSizes[feature.dataKey] == 1) ||
                            (feature.lanRef != 'ddos_protection' &&
                              feature.lanRef != 'additional_bandwidth_gb_month')) && (
                            <Styles.Feature style={{ alignItems: 'center' }} key={feature.id}>
                              <Icon name="check" />
                              <P>
                                <Trans
                                  i18nKey={
                                    data['additional_bandwidth_gb_month'] > 1
                                      ? feature.lang_plural
                                      : feature.lanRef == 'cpu'
                                      ? serverVmSizes[feature.dataKey] > 1
                                        ? `vs/instance/create.step1_cpugen_${serverVmSizes.vcpugen}_plural`
                                        : `vs/instance/create.step1_cpugen_${serverVmSizes.vcpugen}`
                                      : serverVmSizes[feature.dataKey] > 1
                                      ? feature.lang_plural
                                      : feature.lang
                                  }
                                  values={{
                                    count:
                                      feature.lanRef == 'additional_bandwidth_gb_month'
                                        ? data['additional_bandwidth_gb_month']
                                        : serverVmSizes[feature.dataKey],
                                  }}
                                  components={{ highlight: <Highlight /> }}
                                />
                              </P>
                            </Styles.Feature>
                          ),
                      )}
                    </Styles.Features>
                  </Styles.ServerSizeCardSC>
                </Styles.IPText>
              </Grid>
            </ConditionalFragment>
            <Grid container>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicBottomMargin>
                  <Heading small name={'vs/instance.string31'} />
                </Styles.PublicBottomMargin>
              </Grid>
              <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicMarginLeft>
                  <div className="mb-lg-0 mb-sm-3 mb-3 mt-1">
                    <EditLabel
                      labelText={data.label}
                      data={data}
                      managerVmRefetch={managerVmRefetch}
                      allTags={allTags}
                      managerVmIsFetching={managerVmIsFetching}
                      isTags={isTags}
                      type={type}
                      statusOfServer={statusOfServer}
                      openTag={openTag}
                      handleClose={handleClose}
                      handleOpen={handleOpen}
                      setting
                    />
                  </div>
                </Styles.PublicMarginLeft>
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicBottomMargin>
                  <Heading small name={'vs/instance.string122'} />
                </Styles.PublicBottomMargin>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicMarginLeft>
                  {get(network, 'networks', []).map((network) => {
                    return network.eth0?.map((eth) => {
                      return eth.ipv4?.map((ip) => (
                        <Grid container key={ip.ip}>
                          {ip.type == 'primary' ? <Styles.IPText>{ip.ip}</Styles.IPText> : null}
                        </Grid>
                      ));
                    });
                  })}
                </Styles.PublicMarginLeft>
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicBottomMargin>
                  <Heading small name={'vs/instance.string210'} />
                </Styles.PublicBottomMargin>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicMarginLeft>
                  {get(networkIpv6, 'networks', []).map((network) => {
                    return network.eth2?.map((eth) => {
                      return eth.ipv6?.map((ip) => (
                        <Grid container key={ip.ip}>
                          {ip.ip != '' ? (
                            <Styles.IPText>
                              {ip.ip}
                              {ip?.netmask}
                            </Styles.IPText>
                          ) : (
                            <Styles.IPText>
                              {t('vs/instance.string211')}
                              {ipV6IsRefetching && <img src={LoadingImage} width={20} />}
                            </Styles.IPText>
                          )}
                        </Grid>
                      ));
                    });
                  })}
                </Styles.PublicMarginLeft>
              </Grid>
            </Grid>
          </>
        )}
        <Grid container>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Styles.PublicBottomMargin>
              <Heading small name={'vs/instance.string118'} />
            </Styles.PublicBottomMargin>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Styles.PublicMarginLeft>
              <Styles.IPText>{moment(data.date_deployment_ordered).format('lll')}</Styles.IPText>
            </Styles.PublicMarginLeft>
          </Grid>
        </Grid>
        {type == 'vs' && (
          <Grid container>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <Styles.PublicBottomMargin>
                <Heading small name={'vs/instance.string180'} />
              </Styles.PublicBottomMargin>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <Styles.PublicMarginLeft>
                <Styles.IPText style={{ textTransform: 'capitalize' }}>{data?.billing_schedule}</Styles.IPText>
              </Styles.PublicMarginLeft>
            </Grid>
          </Grid>
        )}
        {type == 'vs' && data?.billing_schedule != 'hourly' && (
          <Grid container>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <Styles.PublicBottomMargin>
                <Heading small name={'vs/instance.string196'} />
              </Styles.PublicBottomMargin>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <Styles.PublicMarginLeft>
                <Styles.IPText style={{ textTransform: 'capitalize' }}>
                  {moment(data.next_payment_date).format('ll')}
                </Styles.IPText>
              </Styles.PublicMarginLeft>
            </Grid>
          </Grid>
        )}

        {type === 'bm' && (
          <Grid container>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <Styles.PublicBottomMargin>
                <Heading small name={'vs/instance.string119'} />
              </Styles.PublicBottomMargin>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <Styles.PublicMarginLeft>
                <Styles.IPText style={{ textTransform: 'capitalize' }}>
                  {moment(data.next_payment_date).format('lll')}
                </Styles.IPText>
              </Styles.PublicMarginLeft>
            </Grid>
          </Grid>
        )}

        <Grid container>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Styles.PublicBottomMargin>
              <Heading small name={'vs/instance.string120'} />
            </Styles.PublicBottomMargin>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Styles.PublicMarginLeft>
              <Styles.IPText style={{ textTransform: 'capitalize' }}>
                {`${data.os_name || t('bm/instance.string41')}${data.os_subname ? `, ${data.os_subname}` : ''}`}
              </Styles.IPText>
            </Styles.PublicMarginLeft>
          </Grid>
        </Grid>
        {type === 'bm' && (
          <>
            <Grid container>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicBottomMargin>
                  <Heading small name={'bm/instance.string39'} />
                </Styles.PublicBottomMargin>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Styles.PublicMarginLeft>
                  <Styles.IPText>{data?.sn || t('bm/instance.string41')}</Styles.IPText>
                </Styles.PublicMarginLeft>
              </Grid>
            </Grid>
            <ConditionalFragment condition={rights.bmprice}>
              <Grid container>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Styles.PublicBottomMargin>
                    <Heading small name={'bm/instance.string42'} />
                  </Styles.PublicBottomMargin>
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Styles.PublicMarginLeft>
                    <Styles.IPText>
                      {'$'}
                      {data.price_monthly_usd}
                    </Styles.IPText>
                  </Styles.PublicMarginLeft>
                </Grid>
              </Grid>
            </ConditionalFragment>
          </>
        )}
        <Grid container>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Styles.PublicBottomMargin>
              <Heading small name={type == 'bm' ? 'bm/instance.string57' : 'vs/instance.string114'} />
            </Styles.PublicBottomMargin>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Styles.PublicMarginLeft>
              <Styles.IPText>{data.id}</Styles.IPText>
            </Styles.PublicMarginLeft>
          </Grid>
        </Grid>
      </div>
      <div className="second">
        <Grid container>
          <Grid xs={12} className="pt-1">
            <Styles.PublicMargin>
              <Heading small name={type == 'bm' ? 'bm/instance.string58' : 'vs/instance.string115'} />
            </Styles.PublicMargin>
          </Grid>
          <Grid xs={12}>
            <Grid container>
              <Styles.PublicMarginLeft>
                {checkIpQuantity(0) ? (
                  <Styles.PublicIPParaH6 className="mt-3">{t('bm/instance.string59')}</Styles.PublicIPParaH6>
                ) : (
                  <>
                    {get(network, 'networks', []).map((network) => {
                      return network.eth0?.map((eth) => {
                        return eth.ipv4?.map((ip, index) => (
                          <span
                            key={index}
                            style={{ ...checkDisabledItem(ip.ip) }}
                            className="d-flex align-items-center"
                          >
                            <IPContainer ip={ip.ip} ipData={ip}>
                              <ConditionalFragment condition={type === 'vs' && rights.vsipdelete}>
                                <CustomButton
                                  pointerEvents={checkDisabledItem(ip.ip)}
                                  title={'vs/instance.string116'}
                                  buttonStyles={{
                                    marginLeft: '5px',
                                    padding: '3px 15px',
                                    ...(checkIpQuantity(1) ? disableStyles : {}),
                                  }}
                                  onClick={() => handleDelete(ip.ip)}
                                  isLoading={deletedItem === ip.ip && deleteIpLoad}
                                />
                              </ConditionalFragment>
                            </IPContainer>
                          </span>
                        ));
                      });
                    })}
                  </>
                )}
              </Styles.PublicMarginLeft>
            </Grid>
            <Styles.PublicMarginLeft>
              <Styles.PublicIPParaH6>
                {t(type === 'vs' ? `vs/instance.string117` : 'bm/instance.string60')}
              </Styles.PublicIPParaH6>
              {type === 'vs' && (
                <div className="pt-2 d-flex align-items-center">
                  <div className="pt-2 pr-3">
                    <Toggle handleChange={handlePublicToggle} value="active" checked={preferencePublicEnabled} />
                  </div>
                  <Styles.PublicIPParaH6>
                    {t(`vs/instance.string223`)}
                    {refreshServerLoading && <img src={LoadingImage} width={20} />}
                  </Styles.PublicIPParaH6>
                </div>
              )}
            </Styles.PublicMarginLeft>
          </Grid>
        </Grid>
        <ConditionalFragment condition={type === 'vs' && rights?.vsipadd && data?.billing_schedule == 'hourly'}>
          <Grid container>
            <Grid xs={12}>
              <Styles.PublicMargin>
                <Heading isIcon={false} small name={'vs/instance.string123'} />
              </Styles.PublicMargin>
            </Grid>
            <Grid xs={12}>
              <Styles.PublicMarginLeft>
                <AddIP
                  type={type}
                  howManyIps={network.can_add_ipv4_ips}
                  network={network}
                  data={data}
                  ipRefetch={ipRefetch}
                  managerVmRefetch={managerVmRefetch} // REFETCH VS/BM PANEL PAGE.
                />
              </Styles.PublicMarginLeft>
            </Grid>
          </Grid>
        </ConditionalFragment>
        <ConditionalFragment condition={type == 'vs'}>
          <Grid container>
            <Grid xs={12} className="pt-1">
              <Styles.PublicMargin>
                <Heading small name={'vs/instance.string225'} />
              </Styles.PublicMargin>
            </Grid>
            <Grid xs={12}>
              {hasEth2IPv6 && (
                <Grid container>
                  <Styles.PublicMarginLeft>
                    {get(networkIpv6, 'networks', []).map((network) => {
                      return network.eth2?.map((eth) => {
                        return eth.ipv6?.map((ip, index) => (
                          <span key={index} className="d-flex align-items-center">
                            <IPContainer ip={`${ip.ip}${ip?.netmask}`} ipData={ip}>
                              <ConditionalFragment condition={type === 'vs' && rights.vsipdelete}>
                                <CustomButton
                                  pointerEvents={disableStyles}
                                  title={'vs/instance.string116'}
                                  buttonStyles={{
                                    marginLeft: '5px',
                                    padding: '3px 15px',
                                    ...disableStyles,
                                  }}
                                />
                              </ConditionalFragment>
                            </IPContainer>
                          </span>
                        ));
                      });
                    })}
                  </Styles.PublicMarginLeft>
                </Grid>
              )}
              <Styles.PublicMarginLeft>
                {hasEth2IPv6 && <Styles.PublicIPParaH6>{t(`vs/instance.string117`)}</Styles.PublicIPParaH6>}
                <div className={`${hasEth2IPv6 ? 'pt-3' : 'pt-2'} d-flex align-items-center`}>
                  <div className="pt-2 pr-3">
                    <Toggle handleChange={handlePublicV6Toggle} value="active" checked={preferencePublicV6Enabled} />
                  </div>
                  <Styles.PublicIPParaH6>
                    {t(`vs/instance.string224`)}
                    {(refreshServerLoading || ipV6IsRefetching) && <img src={LoadingImage} width={20} />}
                  </Styles.PublicIPParaH6>
                </div>
                {!hasEth2IPv6 && (
                  <Styles.PublicIPParaH6 className="mt-3">{t(`vs/instance.string230`)}</Styles.PublicIPParaH6>
                )}
              </Styles.PublicMarginLeft>
            </Grid>
          </Grid>
        </ConditionalFragment>
        <ConditionalFragment condition={type == 'vs' && hasEth2RoutedIP}>
          <Grid container>
            <Grid xs={12} className="pt-1">
              <Styles.PublicMargin>
                <Heading isIcon={false} small name={'vs/instance.string226'} />
              </Styles.PublicMargin>
            </Grid>
            <Grid xs={12}>
              <Grid container>
                <Styles.PublicMarginLeft>
                  {get(networkIpv6, 'networks', []).map((network) => {
                    return network.eth2?.map((eth) => {
                      return eth.routed?.map((ip, index) => (
                        <span
                          key={index}
                          style={{ ...checkDisabledItemV6(ip.route) }}
                          className="d-flex align-items-center"
                        >
                          <IPContainer ip={ip.route} ipData={ip}>
                            <ConditionalFragment condition={type === 'vs'}>
                              <CustomButton
                                pointerEvents={checkDisabledItemV6(ip.route)}
                                title={'vs/instance.string116'}
                                buttonStyles={{
                                  marginLeft: '5px',
                                  padding: '3px 15px',
                                }}
                                onClick={() => handleDeleteIpV6(ip)}
                                isLoading={(deletedV6Item === ip.route && deleteIpv6Loading) || ipV6IsRefetching}
                              />
                            </ConditionalFragment>
                          </IPContainer>
                        </span>
                      ));
                    });
                  })}
                </Styles.PublicMarginLeft>
              </Grid>
            </Grid>
          </Grid>
        </ConditionalFragment>
        <ConditionalFragment condition={type === 'vs'}>
          <Grid container>
            <Grid xs={12}>
              <Styles.PublicMargin>
                <Heading isIcon={false} small name={'vs/instance.string212'} />
              </Styles.PublicMargin>
            </Grid>
            <Grid xs={12}>
              <Styles.PublicMarginLeft>
                <Styles.AddingIP>
                  <div className="d-flex flex-wrap align-items-center">
                    <Select
                      style={{ marginTop: '0px', width: '100%', maxWidth: 200 }}
                      value={selectedValueIp}
                      options={ipV6SubnetArr}
                      name={'selectedIpV6'}
                      onChange={(e) => setSelectedValueIp(e.target.value)}
                    />
                    <CustomButton
                      title={'vs/instance.string228'}
                      buttonStyles={buttonStyle}
                      onClick={handleIpv6Subnet}
                      isLoading={addIpV6SubnetLoading}
                    />
                  </div>
                  <Styles.PublicIPParaH6 className="mt-3">{t('vs/instance.string229')}</Styles.PublicIPParaH6>
                </Styles.AddingIP>
              </Styles.PublicMarginLeft>
            </Grid>
          </Grid>
        </ConditionalFragment>
        {type === 'vs' && (
          <Grid container>
            <Grid xs={12}>
              <Styles.PublicMargin>
                <Heading small name={type == 'bm' ? 'bm/instance.string63' : 'vs/instance.string126'} />
              </Styles.PublicMargin>
            </Grid>
            <Grid xs={12}>
              <Grid xs={12}>
                <Styles.PublicMarginLeft>
                  {get(network, 'networks', []).map((network) => {
                    return network.eth1?.map((eth) => {
                      return eth.ipv4?.map((ip, index) => (
                        <Grid item xs={12} className="d-flex align-items-center w-100" key={index}>
                          <div className="d-flex align-items-center">
                            <IPContainer ip={ip.ip} ipData={ip} />
                          </div>
                        </Grid>
                      ));
                    });
                  })}
                  <div className="pt-2 d-flex align-items-center">
                    <div className="pt-2 pr-3">
                      <Toggle handleChange={handleToggle} value="active" checked={preferenceEnabled} />
                    </div>
                    <Styles.PublicIPParaH6>
                      {t(data?.private_vlan == 1 ? `vs/instance.string218` : 'vs/instance.string217')}
                      {refreshServerLoading && <img src={LoadingImage} width={20} />}
                    </Styles.PublicIPParaH6>
                  </div>
                </Styles.PublicMarginLeft>
              </Grid>
            </Grid>
          </Grid>
        )}
      </div>
    </Styles.InfoDetail>
  );
};

export const Info = React.memo(InfoManager);
